module.exports = __webpack_public_path__ + "img/logo.dc960e4c.png";